
/* eslint-disable */
import { VNode, CreateElement } from "vue";
import { Vue, Prop, Component } from "vue-property-decorator";

import MenuLinkItem from "./MenuLink.vue";
import { MenuItem } from "@/types";

interface MenuItemType extends MenuItem {
  show?: boolean;
  level?: string;
}

function getLastValue(set: Set<string>): string | undefined {
  let value;
  for (value of set);
  return value;
}

const renderMenu = (h: CreateElement, list: Array<MenuItemType>): VNode => {
  return h(
    "ul",
    {
      class: {
        menu__list: true,
        "menu-list": true,
        "reset--list-style": true
      }
    },
    list.map((item: MenuItemType, index: number) =>
      h(
        "li",
        {
          class: {
            "menu-list__item": true,
            show: item.show
          }
        },
        [
          h(MenuLinkItem, {
            props: {
              item: {
                ...item,
                text: `${item.text} ${item.level}`
              }
            },
            class: {
              "menu-list__link": true
            },
            attrs: {
              "data-id": item.level
            }
          }),
          ...[item.subMenu && item.subMenu.length ? renderMenu(h, item.subMenu) : []]
        ]
      )
    )
  );
};

@Component({})
export default class Menu extends Vue {
  @Prop({ type: Array, required: true }) list!: Array<MenuItem>;
  //https://github.com/vuejs/vue/issues/2410#issuecomment-318487855 :(
  setChangeTracker: number = 1; // :(
  currentClicedLinksId: Set<string> = new Set();

  mounted() {}

  get normalizedList(): Array<MenuItemType> {
    //TODO make deep copy
    const copy = [...this.list];

    const iter = (items: Array<MenuItemType>, level: string): Array<MenuItemType> => {
      return items.map((item: MenuItemType, index: number) => {
        const newlevel = `${level ? level + "." : ""}${index + 1}`;
        item.show = this.currentClicedLinksId.has(newlevel);
        item.level = newlevel;
        if (item.subMenu) item.subMenu = iter(item.subMenu, newlevel);
        return item;
      });
    };

    if (this.setChangeTracker) return iter(copy, "");

    return copy;
  }

  onSpaceClick(id: string) {
    const isSubTree = () => {
      const discardLastItem = id
        .split(".")
        .slice(0, -1)
        .join(".");
      const subIds = discardLastItem === "." ? id : discardLastItem;

      return this.currentClicedLinksId.has(subIds);
    };

    if (!isSubTree()) this.onBackquoteClick();

    this.currentClicedLinksId.add(id);
    this.setChangeTracker += 1;
  }

  onBackspaceClikc() {
    const lastVal = getLastValue(this.currentClicedLinksId);
    if (lastVal) {
      this.setChangeTracker -= 1;
      this.currentClicedLinksId.delete(lastVal);

      // focus to last elem
      this.focusToElement();
    }
  }

  onBackquoteClick() {
    this.currentClicedLinksId = new Set();
    this.setChangeTracker = 1;
    this.focusToElement('1');
  }

  focusToElement(val: string | null = null) {
    const lastVal = val ? val : getLastValue(this.currentClicedLinksId);
    if (lastVal) {
      const link: HTMLElement | null = document.querySelector(`a[data-id="${lastVal}"]`);
      if (link) link.focus();
    }
  }

  public render(h: CreateElement): VNode {
    return h(
      "div",
      {
        class: {
          menu: true
        },
        on: {
          keyup: ({ code, target }: KeyboardEvent) => {
            if (!target) return;
            //@ts-ignore
            const id = target.dataset && target.dataset.id;
            if (!id) return;

            const dispathByCode: {
              [key: string]: VoidFunction;
            } = {
              Space: () => this.onSpaceClick(id),
              Backspace: () => this.onBackspaceClikc(),
              Backquote: () => this.onBackquoteClick()
            };

            if (typeof dispathByCode[code] !== "undefined") dispathByCode[code]();
          },
          mouseover: (e: MouseEvent) => {
            this.onBackquoteClick();
          }
        }
      },
      [renderMenu(h, this.normalizedList)]
    );
  }
}
